import type { ReactElement, ReactNode } from 'react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';

type ItemProps = {
  href: string;
  children: ReactNode;
};

function Item({ href, children }: ItemProps): ReactElement {
  const { pathname } = useLocation();

  return (
    <NavItem>
      <NavLink active={pathname === href} tag={Link} to={href}>
        {children}
      </NavLink>
    </NavItem>
  );
}

type NavTabsProps = {
  children: ReactNode;
};

function NavTabs({ children }: NavTabsProps): ReactElement {
  return <Nav tabs>{children}</Nav>;
}

export default Object.assign(NavTabs, {
  Item
});
